import React, { useContext, useEffect, useState, useRef } from "react";
import { Container, Modal, ModalHeader } from "reactstrap";
import Button from "@restart/ui/Button";
import ToasterModal from "../../shared/ToasterModal";
import MovePopUp from "../../shared/MovePopUp";
import createIcon from "../../../images/AddNew.svg";
import "./Leads.scss";
import "../../../scss/commonfields.scss";
import CreateLeadForm from "./NewLead/CreateLeadForm";
import ModalComponent from "../../shared/ModalComponent";
import ActionItemForm from "./ActionItemForm";
import "../../../components/shared/shared.scss";
import MissingInfoFC from "./MissingInfoFC";
import SelectExistingContact from "./SelectExistingContact";
import Service from "../../../services";
import { AxiosError, AxiosResponse } from "axios";
import { catchError } from "../../../utils/Utils";
import { transformDateWithDash } from "../../../utils/dateUtil";
import { toast } from "react-toastify";
import { BankUserContext } from "../../../bankUserContext";
import FinSpinner from "../../../commonfields/FinSpinner";
import GenericTracker from "../../tracker/GenericTracker";
import { TriggerContext } from "../../../Context/TriggerContext";
import { useParams } from "react-router-dom";
import { localToBinaryFileConverter } from "../../../utils/localToBinaryFileConverter";
import FileViewerModal from "../../shared/FileViewerModal";
import { fileFormatSupported } from "../../../utils/GeneralUtils";

interface ICreateLeadMaster {
  getProducts?: any;
  genericTracker?: boolean;
  fromTracker?: boolean;
  leadData?: any;
  handleGenericData?: any;
  clientId?: string;
  pclientId?: string;
  refreshTrackers?: () => void;
  fromDetailsPage?: boolean;
  menuOption?: any;
  editLead?: boolean;
  genericTrackerLead?: any;
  buttonName?: string;
  editLeadBtn?: boolean;
  editLeadData?: any;
  getLeadData?: any;
  isConfirmToCreate?: boolean;
  firstBtn?: boolean;
  companyLogo?: any;
  getCompanyLogo?: any;
  clientProductsContactMappingId?: string;
  selectedClient?: any;
}
interface options {
  id: string;
  text: string;
  value: string;
}

const CreateLeadMaster: React.FC<ICreateLeadMaster> = (
  props: ICreateLeadMaster
) => {
  const [leadData, setLeadData] = useState([]);
  const [isExistingCreateLead, setIsExistingCreateLEad] =
    useState<boolean>(false);
  const [showConfirmCreateModal, setShowConformCreateModal] =
    useState<boolean>(false);
  const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
  const [confirmCloseModal, setConfirmCloseModal] = useState<boolean>(false);
  const [leadCreated, setLeadCreated] = useState<boolean>(false);
  const [formChange, setFormChange] = useState<number>(0);
  const [createActionModal, setCreateActionModal] = useState<boolean>(false);
  const [moveContactingModal, setMoveContactingModal] =
    useState<boolean>(false);
  const [missingPopUp, setMissingPopUp] = useState<boolean>(false);
  const [actionMissingFields, setActionMissingFields] = useState<string[]>([]);
  const [missingFields, setMissingFields] = useState<string[]>([]);
  const [buttonName, setButtonName] = useState<string>("Create Lead");
  const [createLeadValues, setCreateLeadValues] = useState<any>([]);
  const [initialValues, setInitialValues] = useState<any>();
  const [actionDefaultProduct, setActionDefaultProduct] = useState<any>();
  const [productsData, setProductsData] = useState<options[]>([]);
  const [emailTypesData, setEmailTypesData] = useState<options[]>([]);
  const [phoneTypesData, setPhoneTypesData] = useState<options[]>([]);
  const [statesData, setStatesData] = useState<options[]>([]);
  const [existingContactPopUp, setExistingContactPopUp] =
    useState<boolean>(false);
  const [clientId, setClientId] = useState<any>();
  const [clientProductId, setClientProductId] = useState<string>("");
  const [actionInteractionsData, setActionInteractionsData] = useState<
    options[]
  >([]);
  const [actionContactsData, setActionContactsData] = useState<options[]>([]);
  const [actionProductsData, setActionProductsData] = useState<options[]>([]);
  const [defaultContact, setDefaultContact] = useState<any>();
  const [defaultContactId, setDefaultContactId] = useState<string>("");
  const [defaultProductId, setDefaultProductId] = useState<string>("");
  const [businessName, setBusinessName] = useState<string>("");
  const context = useContext(BankUserContext);
  const [trackerMoveContactModal, setTrackerMoveContactModal] =
    useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [selectedProductInfo, setSelectedProductInfo] = useState<any>({});
  const [removeValues, setRemoveValues] = useState<boolean>(false);
  const [autoBusinessInfo, setAutoBusinessInfo] = useState<any>({});
  const [assignActionTo, setActionItemTo] = useState<any>([]);
  const [defaultAssignActionTo, setDefaultAssignActionTo] = useState<any>(); //
  const [documentsData, setDocumentsData] = useState<any>();
  const [viewFile, setViewFileDoc] = useState<boolean>(false);

  const { clientProductsId } = useParams();

  const service = new Service();
  const triggerContext = useContext(TriggerContext);

  const childRef = useRef<{ triggerChildFunction: () => void } | null>(null);

  const callFunctioninChild = () => {};

  const moveToContactStatus = () => {
    setLoader(true);
    const data = {
      sections: "changeClientStatus",
      workflowRelated: true,
      orgId: context.bankuserDetails?.organization.orgId,
      clientProductsId: clientProductId,
      clientId: clientId,
      orgLevelProductId: context.orgProductsList[0]?.orgLevelProductId,
      moveToStatus: props?.menuOption?.value || "Contacting",
    };
    service
      .moveToContact(data)
      .then((response: AxiosResponse<any>) => {
        props.refreshTrackers && props.refreshTrackers();
        setCreateLeadValues({});
        setAutoBusinessInfo({});
      })
      .catch((error: AxiosError) => {
        // toast.error("Something Went Wrong");
        catchError(error, true);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleTrackerToMoveForward = (value: boolean) => {
    if (props?.menuOption?.type === "Archive") {
      // not to get missing fields pop ups etc for archive
      setTrackerMoveContactModal(false);
      // moveToContactStatus();   not calling updateEntity api for archive
      props?.refreshTrackers && props?.refreshTrackers(); // to refresh the trackers
    } else if (props?.menuOption?.type === "Reactivate") {
      if (value) {
        const data = {
          isArchive: false,
          clientProductsId: props?.leadData?.clientProductsId,
          clientId: props?.leadData?.clientId,
          productCode: props?.leadData?.productCode,
        };
        service
          .reactiveArhiveStatus(data)
          .then(() => {
            props?.refreshTrackers && props?.refreshTrackers();
          })
          .catch((error: AxiosError) => catchError(error, true));
      }
      setTrackerMoveContactModal(false);
    } else {
      if (value) {
        setTrackerMoveContactModal(false);
        if (actionMissingFields.length !== 0) {
          setMissingFields(actionMissingFields);
          setMissingPopUp(true);
        }
        if (actionMissingFields.length === 0) {
          if (createLeadValues.actioncount > 0) {
            moveToContactStatus(); //api call
            setTrackerMoveContactModal(false);
          } else {
            getCreateActionsDropDownData();
            setCreateActionModal(true);
          }
        }
      } else {
        setTrackerMoveContactModal(false);
      }
    }
  };

  useEffect(() => {
    if (props.leadData !== undefined && props?.fromTracker) {
      //from tracker
      if (Object.keys(props.leadData).length > 0) {
        const modifiedLead = {
          ...props.leadData,
          contactStreetAddress: props?.leadData?.streerAddress,
          contactUnitSuite: props?.leadData?.unitSuite,
          contactCity: props?.leadData?.city,
          contactState: props?.leadData?.state,
          contactZipCode: props?.leadData?.zipCode,
          contactEmail: props?.leadData?.email,
          contactEmailType: props?.leadData?.emailType,
          contactPhone: props?.leadData?.phone,
          phExt: props?.leadData?.phoneExt,
          contactPhoneType: props?.leadData?.phoneType,
          //
          businessState: props?.leadData?.businessState,
          internalNotes: props?.leadData?.internalNotes,

          //
          clientProductId: props?.leadData?.clientProductsId,
          genericTracker: true,
        };
        setClientId(props.leadData.clientId);
        setClientProductId(props.leadData.clientProductsId);
        missingFieldsFunction(modifiedLead);
        props?.fromTracker && setCreateLeadValues(modifiedLead);
        props?.fromTracker && setTrackerMoveContactModal(true);
      }
    }
  }, [props.leadData]);

  useEffect(() => {
    if (props.editLeadBtn && props.buttonName === "Save") {
      setButtonName("Save");
      handleEditLead();
    }
  }, [props.editLead]);

  useEffect(() => {
    getAddContact();
  }, [businessName]);

  const handleEditLead = () => {
    getCreateLeadDropDownData();
    const data = {
      orgId: context.bankuserDetails?.organization.orgId,
      screen: "ProspectsTR",
      sections: "getClientById",
      isJsonReturnObject: false,
      clientId: props?.clientId,
      clientProductId: clientProductsId,
    };
    if (childRef.current) {
      childRef.current.triggerChildFunction();
    }
    // setLoader(true);
    service
      .getClients(data)
      .then((response: AxiosResponse<any>) => {
        const lead = response?.data[0];
        const modifiedLead = {
          ...lead,
          contactStreetAddress: lead?.streerAddress,
          contactUnitSuite: lead?.unitSuite,
          contactCity: lead?.city,
          contactState: lead?.state,
          contactZipCode: lead?.zipCode,
          contactEmail: lead?.email,
          contactEmailType: lead?.emailType,
          contactPhone: lead?.phone,
          contactPhoneType: lead?.phoneType,
          //
          businessState: lead?.businessState,
          internalNotes: lead?.internalNotes,
        };

        if (lead?.profileDocId) {
          service.getLogo(lead.profileDocId).then((res: any) => {
            const data = {
              ...modifiedLead,
              photo: res?.data,
            };
            setCreateLeadValues(data);
          });
        } else {
          setCreateLeadValues(modifiedLead);
        }
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });

    createLeadModal();
  };

  useEffect(() => {
    if (removeValues === true) {
      clearValues();
    }
  }, [removeValues]);

  const handleClearValues = () => {
    setRemoveValues(true);
  };

  const clearValues = () => {
    if (
      props?.genericTracker ||
      isExistingCreateLead ||
      !isExistingCreateLead
    ) {
      setCreateLeadValues({});
      setAutoBusinessInfo({});
      setButtonName("Create Lead");
    }
  };

  const getTrackerMoveText = () => {
    return `Move to ${props?.menuOption?.value ?? ""}?`;
  };

  const getCreateLeadDropDownData = () => {
    const dropDownData = {
      roleId: context?.bankRolesData?.roleId,
      screen: "ProspectsTR",
      sections: "productDropDownList",
      isJsonReturnObject: true,
      orgId: context.bankuserDetails?.organization.orgId,
      
    };
    service
      .getDropDownData(dropDownData)
      .then((response: AxiosResponse<any>) => {
        if (response.data) {
          setProductsData(response.data[0].productname);
          setStatesData(response.data[0].states);
          setEmailTypesData(response.data[0].emailtypes);
          setPhoneTypesData(response.data[0].phonetypes);
        }
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };

  const modifiedResponse = (response: options[]) => {
    return response?.map((m: options) => {
      return { ...m, value: m.id };
    });
  };

  const getCreateActionsDropDownData = () => {
    const dropDownData = {
      screen: "ProspectDetails",
      sections: "ClientActionDropDownList",
      isJsonReturnObject: true,
      clientId: clientId,
      orgId: context.bankuserDetails?.organization.orgId,
    };
    service
      .getDropDownData(dropDownData)
      .then((response: AxiosResponse<any>) => {
        if (response.data) {
          setActionProductsData(
            modifiedResponse(response.data[0].product_name)
          );
          setActionContactsData(
            modifiedResponse(response.data[0].client_contacts)
          );
          setActionInteractionsData(
            modifiedResponse(response.data[0].client_interaction)
          );
          setActionItemTo(
            modifiedResponse(
              response.data[0].assigneeList && response.data[0].assigneeList
            )
          );
        }
        const initialValues = {
          action: "",
          product: response.data[0].product_name[0].id,
          contact: response.data[0].client_contacts[0].id,
          nextAction: "",
          notes: "",
          documentTemplate: "",
          assignActionTo: context.bankuserDetails?.userId,
        };
        setInitialValues(initialValues);
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };

  const responseModel = (response: boolean) => {
    setIsExistingCreateLEad(response);
    setShowConformCreateModal(false);
    createLeadButtonClick(); // to open lead form
  };

  const confirmCreateLead = () => {
    if (props.isConfirmToCreate) {
      setShowConformCreateModal(true);
    } else {
      createLeadButtonClick();
    }
  };

  const createLeadButtonClick = () => {
    getCreateLeadDropDownData();
    createLeadModal();
  };

  const handleBusinessName = (name: string) => {
    setBusinessName(name);
  };

  const createLeadModal = () => {
    setShowCreateModal(!showCreateModal);
  };

  const MissingDetailsHeader = () => (
    <div className="title">Missing Information</div>
  );

  const SelectExistingContactHeader = () => (
    <div className="title">Select Existing Contact</div>
  );

  const confirmCloseLeadHandle = (closeTag: boolean) => {
    setFormChange(0);
    if (closeTag) {
      setButtonName("Create Lead");
      setCreateLeadValues({});
      setAutoBusinessInfo({});
      setConfirmCloseModal(false);
      createLeadModal();
    } else {
      setConfirmCloseModal(closeTag);
      setFormChange(1);
    }
  };

  const handleSelectExistingContact = () => {
    setExistingContactPopUp(!existingContactPopUp);
  };

  const handleBusinessData = (values: any) => {
    const data = {
      ...values,
      businessName:
        // createLeadValues?.businessName ||
        values?.businessName || values?.currentFormValues?.businessName,
    };
    const data2 = {
      ...data,
      formValuess: values.currentFormValues,
    };
    setAutoBusinessInfo(data);
    setCreateLeadValues(data2.formValuess);
  };

  const handleSelectButton = (
    clientContactId: string,
    isPrimary: boolean,
    data: any,
    businessName: string,
    parentClientId: string,
    clientId: string
  ) => {
    setExistingContactPopUp(!existingContactPopUp);
    let payload = {
      screen: "ProspectTR",
      sections: "getClientContactsbyOrgId",
      orgId: context.bankuserDetails?.organization.orgId,
      isJsonReturnObject: false,
      businessName: businessName,
      parentClientId: props?.pclientId || props?.clientId,
      // search,
    };

    service
      .getLeadsData(payload)
      .then((res: any) => {
        const contactDetails = res?.data?.filter(
          (each: any) => each.clientContactId === clientContactId
        )?.[0];
        const modifiedLead = {
          ...createLeadValues,
          firstName: contactDetails?.firstName,
          lastName: contactDetails?.lastName,
          title: contactDetails?.title,
          dob: contactDetails?.dob,
          contactStreetAddress: contactDetails?.streetAddress,
          contactUnitSuite: contactDetails?.unitSuite,
          contactCity: contactDetails?.city,
          contactState: contactDetails?.state,
          contactZipCode: contactDetails?.zipCode,
          contactEmail: contactDetails?.email,
          contactEmailType: contactDetails?.emailType,
          contactPhone: contactDetails?.phone,
          phoneExt: contactDetails?.phoneExt || contactDetails?.phone_ext,
          contactPhoneType: contactDetails?.phoneType,
          //
          businessName: contactDetails?.businessName,
          businessStreetAddress: contactDetails?.businessStreetAddress,
          businessUnitSuite: contactDetails?.businessUnitSuite,
          businessCity: contactDetails?.businessCity,
          businessState: contactDetails?.businessState,
          businessZipCode: contactDetails?.businessZipCode,
          //
          account: selectedProductInfo?.account,
          estimatedValue: selectedProductInfo?.estimatedValue,
          expectedClose: selectedProductInfo?.expectedCloseDate,
          percentToSale: selectedProductInfo?.percentToSale,
          productName: selectedProductInfo?.productName,
          //
          clientContactId: clientContactId,
        };

        setCreateLeadValues(modifiedLead);
        if (props?.leadData?.profileDocId) {
          // from traker
          props?.leadData?.profileDocId &&
            service.getLogo(props?.leadData?.profileDocId).then((res: any) => {
              const data = {
                ...modifiedLead,
                photo: res?.data,
              };
              setCreateLeadValues(data);
            });
        } else if (
          props?.editLeadData[0]?.profileDocId &&
          props?.editLeadData[0]?.profileDocId
        ) {
          // from edit lead button
          service
            .getLogo(props?.editLeadData[0]?.profileDocId)
            .then((res: any) => {
              const data = {
                ...modifiedLead,
                photo: res?.data,
              };
              setCreateLeadValues(data);
            });
        }
      })
      .catch((err: any) => {});
  };

  const CreateActionItemHeader = () => (
    <div className="title">Create Action Item</div>
  );

  const handleActionItem = () => {
    if (createActionModal) {
      setCreateActionModal(false);
      setMoveContactingModal(true);
    }
  };

  const handleActionClose = () => {
    setCreateActionModal(!createActionModal);
    setCreateLeadValues({});
    setAutoBusinessInfo({});
  };

  const handleFormChanged = (changedValue: number) => {
    setFormChange(changedValue);
  };

  const getContactId = (name: string) => {
    const contact = actionContactsData.filter(
      (each: options) => each.value === name
    );
    return contact[0].id;
  };

  const getInteractionId = (name: string) => {
    const arr = actionInteractionsData.filter(
      (each: options) => each.value == name
    );
    return arr[0].id;
  };

  const handleActionSave = (values: any) => {
    const actionSaveData = {
      sections: "createClientAction",
      data: {
        actionName: values?.action,
        clientId: clientId,
        clientProductId: clientProductId,
        interactionId: values?.interaction,
        actionContact: values?.contact, //need to send uuid
        actionStatus: "active",
        nextAction: transformDateWithDash(values?.nextActionDate),
        actionNotes: values?.notes,
        assignedTo: values?.assignActionTo,
      },
    };
    service
      .saveActionItem(actionSaveData)
      .then((response: any) => {
        toast.success("Action Saved Successfully..!!");
        triggerContext?.setValue(true);
        if (values?.documentTemplate && values?.documentTemplate.length > 0) {
          const data = {
            section: "actionDocuments",
            clientId: clientId,
            clientActionId: response.data.clientActionId,
            module: "profile",
            clientProductId: clientProductId,
          };
          // setLoader(true);

          service
            .filesSaveAttachment(values?.documentTemplate, data)
            .then((response: any) => {
              // setLoader(false);
            })
            .catch((error: AxiosError) => {
              catchError(error, true);
              // setLoader(false);
            });
        }
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });

    handleActionItem();
  };

  const handleMoveToContacting = (check: boolean) => {
    if (check) {
      moveToContactStatus();
      setMoveContactingModal(false);
      setCreateLeadValues({});
      setAutoBusinessInfo({});
    } else {
      setCreateLeadValues({});
      setAutoBusinessInfo({});
      setMoveContactingModal(false);
    }
  };

  const confirmLeadCreate = (check: boolean) => {
    formChange == 0 && createLeadModal();
    setLeadCreated(!leadCreated);
    setFormChange(1);
    if (check) {
      getCreateActionsDropDownData();
      setLeadCreated(!leadCreated);
      setConfirmCloseModal(false);
      if (actionMissingFields.length !== 0) {
        setMissingFields(actionMissingFields);
        setMissingPopUp(true);
      } else {
        let product = {
          id: 0,
          text: createLeadValues?.productName,
          value: createLeadValues?.productName,
        };
        let contact = {
          id: 0,
          text: createLeadValues?.productName,
          value: createLeadValues?.productName,
        };
        setCreateActionModal(!createActionModal);
      }
    }
    if (check == false) {
      setLeadCreated(!leadCreated);
      setCreateLeadValues({});
      setAutoBusinessInfo({});
      setButtonName("Create Lead");
    }
  };

  const missingFieldsFunction = (formValues: any) => {
    setCreateLeadValues(formValues);
    //check missing  fields to move to Contacts
    const actMissingFields = [];
    if (!formValues.firstName) {
      actMissingFields.push("First Name");
    }
    if (!formValues.lastName) {
      actMissingFields.push("Last Name");
    }
    if (!formValues.title) {
      actMissingFields.push("Title");
    }
    if (!formValues.contactStreetAddress) {
      actMissingFields.push("Contact Street Address");
    }
    if (!formValues.contactCity) {
      actMissingFields.push("Contact City");
    }
    if (!formValues.contactState) {
      actMissingFields.push("Contact State");
    }
    if (!formValues.contactZipCode) {
      actMissingFields.push("Contact Zip Code");
    }
    if (!formValues.businessName) {
      actMissingFields.push("Business Name");
    }
    if (!formValues.businessStreetAddress) {
      actMissingFields.push("Business Street Address");
    }
    if (!formValues.businessCity) {
      actMissingFields.push("Business City");
    }
    if (!formValues.businessState) {
      actMissingFields.push("Business State");
    }
    if (!formValues.businessZipCode) {
      actMissingFields.push("Business Zip Code");
    }
    if (!formValues.productName) {
      actMissingFields.push("Product Name");
    }
    if (!formValues.account) {
      actMissingFields.push("Account");
    }
    if (!formValues.email) {
      if (!formValues.phone) actMissingFields.push("Email or Phone");
    }
    if (!formValues.phone) {
      if (!formValues.email) actMissingFields.push("Email or Phone");
    }

    const uniqueList = [...new Set(actMissingFields)];
    setActionMissingFields(uniqueList);
  };

  const handleMissingEdit = () => {
    setButtonName("Save");
    getCreateLeadDropDownData();
    setMissingPopUp(false);
    setShowCreateModal(true);
  };

  const handleMissingPopUp = () => {
    setMissingPopUp(false);
    setCreateLeadValues({});
    setAutoBusinessInfo({});
  };

  const handleDefaultProductId = (value: string) => {
    setDefaultProductId(value);
  };

  const handleDefaultProduct = (productData: options[], id: string) => {
    const arr = productData.filter((each: options) => each.id === id);
    setActionDefaultProduct(arr[0]);
  };

  const handleDefaultClientId = (value: string) => {
    setClientId(value);
  };

  const handleClientProductId = (value: string) => {
    setClientProductId(value); // from btn
  };

  const handleDefaultContactId = (value: string) => {
    setDefaultContactId(value);
  };

  const handleDefaultAssignee = (assigneeList: options[]) => {
    const arr = assigneeList.filter(
      (each: options) => each.id === context?.bankuserDetails?.userId
    );
    setDefaultAssignActionTo(arr[0]);
  };

  const handleDefaultContact = (contactsData: options[], id: string) => {
    const arr = contactsData.filter((each: options) => each.id === id);
    setDefaultContact(arr[0]);
  };

  const selectProductInformationHandler = (values: any) => {
    setSelectedProductInfo(values);
  };

  const getAddContact = (search = "") => {
    let payload = {
      screen: "ProspectTR",
      sections: "getClientContactsbyOrgId",
      orgId: context.bankuserDetails?.organization.orgId,
      isJsonReturnObject: false,
      businessName: businessName,
      search,
    };
    service
      .getLeadsData(payload)
      .then((res: any) => {
        setLeadData(res.data);
      })
      .catch((err: any) => {});
  };

  const setViewFile = () => {
    setViewFileDoc(!viewFile);
  };

  const openFileViewer = async (document: any) => {
    if (document) {
      const fetchData = async () => {
        try {
          setLoader(true);
          const result: any = await localToBinaryFileConverter(document);
          setDocumentsData(result);
          setViewFileDoc(true);
          setLoader(false);
        } catch (error) {
          setLoader(false);
          console.error("Error converting file:", error);
        }
      };
      const fullType = document.path.split(".");
      const docType = fullType[fullType.length - 1];
      if (fileFormatSupported(docType)) {
        fetchData();
      } else {
        toast.error("FileView is not supported");
      }
    }
  };

  return (
    <>
      {loader ? <FinSpinner /> : ""}
      {!props.fromTracker && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span className="createLead createBtnDetailPage">
            {props.genericTracker && (
              <img
                src={createIcon}
                alt="CreateIcon"
                className="create-new-lead"
              />
            )}
            <button
              onClick={() => {
                // createLeadButtonClick();
                confirmCreateLead();
              }}
              disabled={
                props?.fromDetailsPage &&
                props?.leadData?.[0]?.clientProducts?.length === undefined
              }
              type="button"
            >
              Create New Lead
            </button>
          </span>
        </div>
      )}
      {/* Model for create Lead */}
      <ToasterModal
        confirmCloseHandle={responseModel}
        confirmCloseModel={showConfirmCreateModal}
        confirmText={"Do you want create lead with existing account?"}
      />

      <Modal
        className="popup-modal newLeadModal"
        fullscreen
        size="xl"
        isOpen={showCreateModal}
        toggle={createLeadModal}
      >
        <ModalHeader>
          <Button
            className="closeButon"
            onClick={() =>
              formChange == 0
                ? setShowCreateModal(false)
                : setConfirmCloseModal(true)
            }
          >
            x
          </Button>
        </ModalHeader>
        <CreateLeadForm
          ref={childRef}
          triggerChildFunction={handleEditLead}
          callFromChild={callFunctioninChild}
          toggleHandle={createLeadModal}
          title={"Create New Lead"}
          // leadInfo={generalInfoData}
          handleFormChanged={handleFormChanged}
          confirmLeadCreate={confirmLeadCreate}
          buttonName={buttonName}
          genericTracker={props?.genericTracker}
          fromTracker={props.fromTracker}
          emailTypesData={emailTypesData}
          // handleGenericData={handleGenericData}
          phoneTypesData={phoneTypesData}
          missingFieldsFunction={missingFieldsFunction}
          createLeadValues={createLeadValues}
          handleSelectExistingContact={handleSelectExistingContact}
          productsData={productsData}
          statesData={statesData}
          defaultActionProduct={handleDefaultProductId}
          setClientId={handleDefaultClientId}
          clientProductId={handleClientProductId}
          defaultActionContact={handleDefaultContactId}
          refreshTrackers={props?.refreshTrackers} //refresh Trackers
          sendBusinessName={handleBusinessName}
          handleClearValues={handleClearValues}
          businessData={
            (props?.leadData || props?.editLeadData) &&
            (props?.leadData?.[0]?.businessInfo?.[0] ||
              props?.editLeadData?.[0]?.businessInfo?.[0])
          }
          // productInfo={
          //   props?.leadData?.[0]?.clientProducts !== null
          //     ? props?.leadData?.[0]?.clientProducts?.[0]
          //     : ""
          // }
          productInfo={
            props?.leadData?.[0]?.clientProducts?.[0] &&
            props?.leadData?.[0]?.clientProducts?.[0]
          }
          clientProductsContactMappingId={props?.clientProductsContactMappingId}
          selectProductInformation={selectProductInformationHandler}
          fromDetailsPage={props.fromDetailsPage}
          parentClientId={props?.pclientId}
          editLeadBtn={props?.editLeadBtn}
          isExistingCreateLead={isExistingCreateLead}
          leadData={leadData}
          handleBusinessData={handleBusinessData}
          autoBusinessInfo={autoBusinessInfo}
          getLeadData={props?.getLeadData}
          companyLogo={props?.companyLogo}
          getProducts={props?.getProducts}
          getCompanyLogo={props?.getCompanyLogo}
        />
      </Modal>
      {/* Confirmation close Modal  */}
      <ToasterModal
        confirmCloseHandle={confirmCloseLeadHandle}
        confirmCloseModel={confirmCloseModal}
        confirmText={"Changes will not be saved, are you sure?"}
      />
      {/* Lead Created SuccessFull Modal */}
      <ToasterModal
        headerText={"Lead Successfully Created"}
        className="confirmLeadCreated"
        confirmCloseHandle={confirmLeadCreate}
        confirmCloseModel={leadCreated}
        confirmText={"Create an Action Item?"}
      />
      {/* Create Action Items Modal */}
      <ModalComponent
        showModal={createActionModal}
        modalToggle={handleActionClose}
        className="missingInfoModal actionItemModal"
        getHeaderDetails={CreateActionItemHeader}
      >
        <Container fluid>
          <ActionItemForm
            handleActionItemSave={handleActionSave}
            interactionData={actionInteractionsData}
            contactsData={actionContactsData}
            productsData={actionProductsData}
            initialData={initialValues}
            defaultProduct={actionDefaultProduct}
            defaultContact={defaultContact}
            assignActionToData={assignActionTo}
            defaultAssigneeActionToData={defaultAssignActionTo}
            disableField={true}
            openFileViwer={openFileViewer}
            loader={loader}
          />
        </Container>
      </ModalComponent>
      {/* Move to Contacting Modal */}
      <ToasterModal
        className="confirmLeadCreated moveContactModal"
        headerText={"Action Item Created"}
        confirmCloseHandle={handleMoveToContacting}
        confirmCloseModel={moveContactingModal}
        confirmText={"Move to Contacting?"}
      />
      {/* Missing Info Modal */}
      <ModalComponent
        showModal={missingPopUp}
        modalToggle={handleMissingPopUp}
        getHeaderDetails={MissingDetailsHeader}
        className="missingInfoModal cs-missinginfo-modal"
      >
        <MissingInfoFC
          missingFields={missingFields}
          handleEdit={handleMissingEdit}
        />
      </ModalComponent>
      {/* Select Existing Contact */}
      <ModalComponent
        showModal={existingContactPopUp}
        modalToggle={handleSelectExistingContact}
        getHeaderDetails={SelectExistingContactHeader}
        className=" missingInfoModal selectExistingContact"
      >
        <SelectExistingContact
          handleSelect={handleSelectButton}
          clientId={props?.clientId && props?.clientId}
          businessName={businessName}
          productId={clientProductsId}
          parentClientId={props?.pclientId && props?.pclientId}
          editLeadData={
            (props?.editLeadData && props?.editLeadData[0]) || props?.leadData
          }
          createLeadValues={createLeadValues}
          clientProductsContactMappingId={props?.clientProductsContactMappingId}
        />
      </ModalComponent>
      {/* Tracker Move to Contacting Modal */}
      <MovePopUp
        className="confirmLeadCreated moveContactModal"
        confirmCloseHandle={handleTrackerToMoveForward}
        confirmCloseModel={trackerMoveContactModal}
        getText={getTrackerMoveText}
        menuOptions={props.menuOption}
        selectedClient={props?.selectedClient}
      />
      {/*fileViewer modal pop up */}
      <FileViewerModal
        viewFile={viewFile}
        setViewFile={setViewFile}
        documentsData={documentsData}
      />
    </>
  );
};

export default CreateLeadMaster;
